import React from 'react'
import styled from '@emotion/styled'
import Card from './Card'

import { breakpoints } from 'utils/styles'

var slugify = require('slugify')

const Wrapper = styled.div`
    max-width: 1040px;
    margin: auto;
`

const Container = styled.div`
	display: grid;
    grid-template-columns: repeat(3,1fr);
    grid-gap: 10px 20px;
    @media (max-width: ${breakpoints.tablet}px) {
    	grid-template-columns: repeat(2,1fr);
    	grid-gap: 20px;
    }
    @media (max-width: ${breakpoints.phablet}px) {
    	grid-template-columns: 1fr;
    	grid-gap: 20px;
    }
`


export default ({companies}) => {
	if (!companies)return <div/>

	return (
		<Wrapper>
			<Container>
				{
					companies.map(({node})=>
						<Card item={node} />
					)
				}
			</Container>
		</Wrapper>
	)
}
	